<script setup lang="ts">
import { appConfig } from '@/core/config'
import { createAudio } from '@/core/composables/createAudio'

createAudio('backgroundmusic', appConfig.audios.backgroundmusic)
</script>

<template>
  <router-view />
</template>

<style></style>
